import React, { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import {
  Card,
  CardHeader,
  Container,
  Row,
  Button,
  Table,
  Media,
  Badge,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  Form,
  Col,
  FormGroup,
  CardBody,
  Input,
  ModalHeader,
  ModalFooter,
  ModalBody,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  CustomInput,
  Alert,
  Spinner,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  CardTitle,
  CardSubtitle,
  Label,
  FormFeedback,
} from "reactstrap";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import {
  fetchAllUsers,
  fetchUserDetails,
  updateUserDetails,
  updateUserDetailsReset,
  updateMultiUsers,
  updateMultiUsersReset,
  
} from "redux/ManageUsers/ManageUsersAction";
import {fetchUniversities}  from "redux/Users/UsersActions";
import { fetchCoaches } from "redux/ScheduleTutor/ScheduleTutorActions";
import { customDropdown } from "util/reactCustomStyles";
import classnames from "classnames";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { getUserData } from "redux/UserAuthentication/LoginActions";
import { customDropdownWithBorder } from "util/reactCustomStyles";
import { app, db } from "../../firebase";
import {
  collection,
  getDocs,
  getDoc,
  query,
  where,
  onSnapshot,
  doc,
} from "firebase/firestore";
import DataTable from "react-data-table-component";
import moment from "moment-timezone";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactDatetime from "react-datetime";
import StudentFreeHourLogs from "components/Logs/StudentFreeHourLogs";
import {fetchAppHourUsedLogs,fetchPremiumHourLogs,sendEmailApplicationHourUsed} from "redux/Logs/LogsAction";

const ManageUsersModal = (props) => {
  	const dispatch = useDispatch();
    const history = useHistory();
	const [checkUsers, setCheckUsers] = useState([]);
	const [school, setSchool] = useState('');
	const [universities, setUniversities] = useState([])

	useEffect(() => {
		register("name");

		register("mcatDate");
		register("tutorHours");
		register("inputUworld");
		register("inputAamc");
        register("inputBootcamp");
		register("email");
		register("homeAddress");

		register("tpcEntryDate");
		register("mcatDate");
		register("schoolYear");
		register("university");

		register("selectedCountry");
		register("selectedCity");
		register("selectedState");
		register("postalCode");
		register("tutorHours");
		register("shadowGoal");
		register("clinicalGoal");
		register("volunteerGoal");

		register("ultimateAdvisingStudent");
        register("datPro");
		register("coach");

		register("assignedCoach");

		register("matriculated");

        register("coachTitle")
        register("coachPosition")
        register("coachDentalSchool")
        register("coachDescription")

		// dispatch(
		// fetchAllUsers({
		// 	route: "",
		// 	order: order,
		// 	by: by,
		// 	searchFullName: searchFullName,
		// 	subscriptionFilter: subscription,
		// })
		// );
	}, []);

	const {
		register,
		getValues,
		unregister,
		watch,
		handleSubmit,
		setValue,
		formState: { errors },
	} = useForm();


    const [coachTitle, setCoachTitle] = useState('');
    const [coachPosition, setCoachPosition] = useState('');
    const [coachDentalSchool, setCoachDentalSchool] = useState('');
    const [coachDescription, setCoachDescription] = useState('');
    const [coach, setCoach] = useState(false);
	useEffect(() => {
		if (props.fetchUserDetails.userdetails.length) {
            
            setSelectedUser(props.fetchUserDetails.userdetails[0])
            calculateTotalHours(props.fetchUserDetails.userdetails[0])
            setValue(
                "coach",
                typeof props.fetchUserDetails.userdetails[0].coach != "undefined"
                ? props.fetchUserDetails.userdetails[0].coach
                : false
            );

            setValue(
                "coachTitle",
                typeof props.fetchUserDetails.userdetails[0].coachTitle != "undefined"
                ? props.fetchUserDetails.userdetails[0].coachTitle
                : ""
            );

            setValue(
                "coachPosition",
                typeof props.fetchUserDetails.userdetails[0].coachPosition != "undefined"
                ? props.fetchUserDetails.userdetails[0].coachPosition
                : ""
            );

            setValue(
                "coachDentalSchool",
                typeof props.fetchUserDetails.userdetails[0].coachDentalSchool != "undefined"
                ? props.fetchUserDetails.userdetails[0].coachDentalSchool
                : ""
            );

            setValue(
                "coachDescription",
                typeof props.fetchUserDetails.userdetails[0].coachDescription != "undefined"
                ? props.fetchUserDetails.userdetails[0].coachDescription
                : ""
            );


            setValue("name", props.fetchUserDetails.userdetails[0].name);

            setValue("email", props.fetchUserDetails.userdetails[0].email);
            setValue(
                "homeAddress",
                typeof props.fetchUserDetails.userdetails[0].homeAddress != "undefined"
                ? props.fetchUserDetails.userdetails[0].homeAddress
                : ""
            );

            setValue(
                "tpcEntryDate",
                props.fetchUserDetails.userdetails[0].tpcEntryDate
            );
            setValue("mcatDate", props.fetchUserDetails.userdetails[0].mcatDate);
            setValue(
                "schoolYear",
                typeof props.fetchUserDetails.userdetails[0].schoolYear != "undefined"
                ? props.fetchUserDetails.userdetails[0].schoolYear
                : ""
            );
            setValue(
                "university",
                typeof props.fetchUserDetails.userdetails[0].university != "undefined"
                ? props.fetchUserDetails.userdetails[0].university
                : ""
            );

            setValue(
                "selectedCountry",
                typeof props.fetchUserDetails.userdetails[0].selectedCountry !=
                "undefined"
                ? props.fetchUserDetails.userdetails[0].selectedCountry
                : ""
            );
            setValue(
                "selectedCity",
                typeof props.fetchUserDetails.userdetails[0].selectedCity != "undefined"
                ? props.fetchUserDetails.userdetails[0].selectedCity
                : ""
            );
            setValue(
                "selectedState",
                typeof props.fetchUserDetails.userdetails[0].selectedState !=
                "undefined"
                ? props.fetchUserDetails.userdetails[0].selectedState
                : ""
            );
            setValue(
                "postalCode",
                typeof props.fetchUserDetails.userdetails[0].postalCode != "undefined"
                ? props.fetchUserDetails.userdetails[0].postalCode
                : ""
            );
            setValue("tutorHours", props.fetchUserDetails.userdetails[0].tutorHours);
            setValue("shadowGoal", props.fetchUserDetails.userdetails[0].shadowGoal);
            setValue(
                "clinicalGoal",
                props.fetchUserDetails.userdetails[0].clinicalGoal
            );
            setValue(
                "volunteerGoal",
                typeof props.fetchUserDetails.userdetails[0].volunteerGoal !=
                "undefined"
                ? props.fetchUserDetails.userdetails[0].volunteerGoal
                : 0
            );

            setValue("mcatDate", props.fetchUserDetails.userdetails[0].mcatDate);
            setValue("tutorHours", props.fetchUserDetails.userdetails[0].tutorHours);
            setValue(
                "inputUworld",
                props.fetchUserDetails.userdetails[0].subscriptions?.includes("uworld")
                ? "claimed"
                : "unclaimed"
            );
            setValue(
                "inputAamc",
                props.fetchUserDetails.userdetails[0].subscriptions?.includes("aamc")
                ? "claimed"
                : "unclaimed"
            );

            // setValue(
            //     "inputBootcamp",
            //     props.fetchUserDetails.userdetails[0].subscriptions?.includes("bootcamp")
            //     ? "claimed"
            //     : "unclaimed"
            // );

            setValue(
                "bootcampSubscription",
                typeof props.fetchUserDetails.userdetails[0].ultimateAdvisingStudent !=
                "undefined"  && props.fetchUserDetails.userdetails[0].ultimateAdvisingStudent ?
                    props.fetchUserDetails.userdetails[0].bootcampSubscription == "claimed"
                    ? "claimed" : "unclaimed"
                : "no access"
            );


            setValue(
                "ultimateAdvisingStudent",
                typeof props.fetchUserDetails.userdetails[0].ultimateAdvisingStudent !=
                "undefined"
                ? props.fetchUserDetails.userdetails[0].ultimateAdvisingStudent
                : false
            );

            setValue(
                "datPro",
                typeof props.fetchUserDetails.userdetails[0].datPro !=
                "undefined"
                ? props.fetchUserDetails.userdetails[0].datPro
                : false
            );

            setValue(
                "coach",
                typeof props.fetchUserDetails.userdetails[0].coach != "undefined"
                ? props.fetchUserDetails.userdetails[0].coach
                : false
            );

            setValue(
                "admin",
                typeof props.fetchUserDetails.userdetails[0].admin != "undefined"
                ? props.fetchUserDetails.userdetails[0].admin
                : false
            );

            setValue(
                "assignedCoach",
                typeof props.fetchUserDetails.userdetails[0].assignedCoach !=
                "undefined"
                ? props.fetchUserDetails.userdetails[0].assignedCoach
                : ""
            );
            if (
                typeof props.fetchUserDetails.userdetails[0].assignedCoach !=
                "undefined"
            ) {
                setAssignedCoach(props.fetchUserDetails.userdetails[0].assignedCoach);
            } else {
                setAssignedCoach("");
            }

            setValue(
                "matriculated",
                typeof props.fetchUserDetails.userdetails[0].matriculated !=
                "undefined"
                ? props.fetchUserDetails.userdetails[0].matriculated
                : ""
            );
            if (
                typeof props.fetchUserDetails.userdetails[0].matriculated !=
                "undefined"
            ) {
                setSchool(props.fetchUserDetails.userdetails[0].matriculated);
            } else {
                setSchool("");
            }
		}
	}, [props.fetchUserDetails]);

    
	const [modalUpdateUser, setModalUpdateUser] = useState(false);
	const toggleUpdateUser = () => {
		setModalUpdateUser(!modalUpdateUser);
	};

	const editUserDetails = (e, data) => {
		e.preventDefault();
		
		dispatch(fetchUserDetails({ userId: data.userId }));

		dispatch(fetchUniversities({}));

		setValue("name", "");
		setValue("email", "");
		setValue("homeAddress", "");
		setValue("tpcEntryDate", "");
		setValue("mcatDate", "");
		setValue("schoolYear", "");
		setValue("university", "");
		setValue("selectedCountry", "");
		setValue("selectedCity", "");
		setValue("selectedState", "");
		setValue("postalCode", "");
		setValue("tutorHours", "");
		setValue("shadowGoal", "");
		setValue("clinicalGoal", "");
		setValue("volunteerGoal", "");
		setValue("assignedCoach", "");

        // setCoach(false)
        // setCoachTitle("")
        // setCoachPosition("")
        // setCoachDentalSchool("")
        // setCoachDescription("")

        setValue("coach", false)
        setValue("coachTitle", "")
        setValue("coachPosition", "")
        setValue("coachDentalSchool", "")
        setValue("coachDescription", "")

        setModalUpdateUser(data.modal);


		// setValue("ultimateAdvisingStudent", "");
		// setValue("coach",  "");
	};

    const onSubmit = (data) => {
        data.subscriptions = [];

        if (data.inputAamc == "claimed") {
        data.subscriptions.push("aamc");
        }
        // if (data.inputBootcamp == "claimed") {
        // data.subscriptions.push("bootcamp");
        // }
        if (data.inputUworld == "claimed") {
        data.subscriptions.push("uworld");
        }
        data.handle = props.fetchUserDetails.userdetails[0].handle;
 
        data.coachTitle = getValues("coachTitle")
        data.coachPosition = getValues("coachPosition")
        data.coachDentalSchool = getValues("coachDentalSchool")
        data.coachDescription = getValues("coachDescription")

        dispatch(updateUserDetails(data));

        Swal.fire({
            allowOutsideClick: false,
            didOpen: () => {
            Swal.showLoading();
            },
        });
    };

    useEffect(() => {
        if (props.updateUserDetails.loading) {
            
        } else {
            if(props.updateUserDetails.userdetails.length){
                Swal.fire({
                    title: "Success!",
                    text: "Successfully updated user!",
                    icon: "success",
                    timer: 3000,
                }).then(() => {
                    dispatch(updateUserDetailsReset());
                    // dispatch(
                    // fetchAllUsers({route: ""})
                    // );
                    setModalUpdateUser(false)
                });
            }
        }
    }, [props.updateUserDetails]);

	const handleViewUser = (e, userDetails) => {
		e.preventDefault();
		// dispatch(getUserData({ user: userDetails }));

       
        Swal.fire({
            title: "View as user",
            text: "Do you want to view as "+userDetails.name+"?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(getUserData({ user: userDetails }));
                history.push("/client/dashboard")
            }
        });
            
       

	};

    const handleAssignedCoach = (selectedOption) => {
        setAssignedCoach(selectedOption.value);
        setValue("assignedCoach", selectedOption.value);
    };

  	const [coaches, setCoaches] = useState([]);
  	const [assignedcoach, setAssignedCoach] = useState("");

    useEffect(() => {
        if (props.fetchCoaches.fetchcoaches.length) {
            const coachesArr = props.fetchCoaches.fetchcoaches[0];
            setCoaches(coachesArr);

            const coachesOption = props.fetchCoaches.fetchcoaches[0];
			// coachesOption.unshift({ value: "", label: "Select Coach" });
			setCoachOption(coachesOption);
            
        }
    }, [props.fetchCoaches]);


  useEffect(() => {
    if(props.fetchUniversities.universities.length){
      let universitiesList = props.fetchUniversities.universities[0].universities.sort()
      universitiesList = [...new Set(universitiesList.map((value, index) => {return {value:value, label: value}}))];
      setUniversities(universitiesList)
    }
  }, [props.fetchUniversities.universities])

	const handleUniversityChange = (selectedOption) => {
		setValue("matriculated", selectedOption.value);
		setSchool(selectedOption.value);
	};

 
	const convertDate = (date) => {
        return moment(date).utcOffset(0, false).format('ll');
    }

    const onChangeUltimateAdvisingStudent = (e) => {
   

        if(e.target.value === "true" || e.target.value === true  ){
            setValue("tutorHours", parseInt(props.fetchUserDetails.userdetails[0].tutorHours) + 5)         
        }
        else{
            setValue("tutorHours", parseInt(props.fetchUserDetails.userdetails[0].tutorHours))
        }

        setValue("ultimateAdvisingStudent", e.target.value)
    }

    const onChangeBootcampSubscription = (e) => {
        setValue("bootcampSubscription", e.target.value)        
    }


    const [modal1, setModal1] = useState(false);
    const modalToggle1 = () => setModal1(!modal1);
    const [backdrop1, setBackdrop1] = useState(true);

    const mainopt = ["Log Hours", "View History"];
    const [mainActiveTab, setMainActiveTab] = useState("Log Hours");

    const [userDetailsLoading, setUserDetailsLoading] = useState();
    const [selectedUser, setSelectedUser] = useState("");
    const [totalHour, setTotalHour] = useState(0)
    const [sessionDate, setSessionDate] = useState("")
    const [sessionFrom, setSessionFrom] = useState("")
    const [sessionTo, setSessionTo] = useState("")
    const [noValueError, setNoValueError] = useState()
	const [hideError, setHideError] = useState(true)
    const [hourErrorMsg,setHourErrorMsg] = useState("")
    const [phour, setPhour] = useState(0)
    const [coachOption, setCoachOption] = useState([]);
    const [comment, setComment] = useState("")
    const [psValue, setPsValue] = useState(0)
    const [actValue, setActValue] = useState(0)
    const [miValue, setMiValue] = useState(0)
    const [secValue, setSecValue] = useState(0)
    const [generalValue, setGeneralValue] = useState(0)
    const [selectedHour, setSelectedHour] = useState("");
    
    const useHoursObj = [
        {category: "personal_statement", value: Number(psValue), prev: 0, max: 7},
        {category: "activities", value: Number(actValue) , prev: 0, max: 5},
        {category: "mock_interview", value: Number(miValue) , prev: 0, max: 2},
        {category: "secondaries", value: Number(secValue) , prev: 0, max: 6},
        {category: "general_coaching", value: Number(generalValue) , prev: 0, max: 6},
    ];

    const hourOptions = [
        {
            label: '.5',
            value: '0.5',
        },
        {
            label: '.75',
            value: '0.75',
        },
        {
            label: '1',
            value: '1',
        },
        {
            label: '1.5',
            value: '1.5',
        },
        {
            label: '2',
            value: '2',
        },
    ];

    const handleHours = (data) =>{
        console.log(data)
        if(data.category == "personal_statement"){
            setPsValue(data.value)
        }else if(data.category == "activities"){
            setActValue(data.value)
        }
        else if(data.category == "mock_interview"){
            setMiValue(data.value)
        }else if(data.category == "secondaries"){
            setSecValue(data.value)
        }else if(data.category == "general_coaching"){
            setGeneralValue(data.value)
        }else{
			setPhour(data.value)

		}
        setNoValueError("")
    }

    const handleCommentChange = (e) =>{
        setComment(e.target.value)
    }

    const toggleMain = (tab) => {
        if (mainActiveTab !== tab) setMainActiveTab(tab);
    };

    const handleChangeDate = (e) =>{
		if(typeof e === "object"){
        	setSessionDate(new Date(e.toJSON()));
		}else{
			setSessionDate("");
		}
    }

    const handleChangeFrom = (e) =>{
		if(typeof e === "object"){
        	setSessionFrom(new Date(e.toJSON()));
		}else{
			setSessionFrom("")
		}
    }
    const handleChangeTo = (e) =>{
		if(typeof e === "object"){
			setSessionTo(new Date(e.toJSON()));
		}else{
			setSessionTo("")
		}    
    }


    const  editStudentDetails = (e,userID) =>{

		setAssignedCoach("")
		setSessionDate()
        setSessionFrom()
        setSessionTo()
        setComment()
		setPsValue(0)
        setActValue(0)
		setMiValue(0)
      	setSecValue(0)
        setGeneralValue(0)
		setPhour(0)
		setSelectedHour(0)
        setHideError(true)
        setNoValueError("")
		setHourErrorMsg("")
        setSelectedUser([])
        dispatch(fetchUserDetails({ userId: userID }));
        setModal1(true)
    }

    const calculateTotalHours = (selectedUser) =>{
         if(typeof selectedUser.totalHoursUsed !== "undefined"){
            let total = 0
            selectedUser.totalHoursUsed.map((v,i)=>(
                total+= Number(v.value)
            ))
            setTotalHour(total)
        }else{
            setTotalHour(0)
        }
    }

    const  saveUserSession = () =>{
        setHideError(false)

        let errors = 0
		if(!sessionDate || !sessionFrom || !sessionTo || !comment || !assignedcoach){
			errors = 1
		}else if(psValue === 0 && actValue === 0 && miValue === 0 && secValue === 0 && generalValue === 0 && phour === 0) {
			setNoValueError("Please input hour to a category to apply changes.")
			errors = 1
		}else if(Number(phour) > Number(selectedUser.tutorHours)){
			setPhour(0)
			errors = 1
			setHourErrorMsg( "Deduct hour should not be greater than the current value " )
		}else{
			errors = 0
		}


        if(typeof selectedUser.totalHoursUsed !== "undefined"){

            let updatedHour = []
           
            useHoursObj.forEach(function(d,i){
             
                if(typeof selectedUser.totalHoursUsed[i] !== "undefined"){
                    if(d.category == selectedUser.totalHoursUsed[i].category){
                        let updateValue =   Number(d.value) + Number(selectedUser.totalHoursUsed[i].value)
                        d.prev = selectedUser.totalHoursUsed[i].value
                        d.value = updateValue
                    }
                }
                updatedHour.push(d)
            });
          
            if(errors == 1){
              
            }else{
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to add hours?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes,'
                }).then((result) => {
                    if (result.isConfirmed) {
						setModal1(false)
                        const setData = {
                            by: props.userDetails.handle,
                            updatedBy: assignedcoach, //? assignedcoach : props.userDetails.handle,
                            handle: selectedUser.handle,
                            updateUsedHour: updatedHour,
                            date: moment.utc(sessionDate).format(),
                            startTime: moment.utc(sessionFrom).format(),
                            endTime: moment.utc(sessionTo).format(),
                            comment: comment,
                            mailDetails: {
                                coach: props.userDetails.name,
                                coachEmail: props.userDetails.email,
                                student: selectedUser.name,
                                studentEmail: selectedUser.email,

                            }
                        }
						if(phour != 0){
							setData.updatePremiumHour = {
								category: "premium_hour",
								prev: Number(selectedUser.tutorHours),
								value : Number(selectedUser.tutorHours) - Number(phour)
							}
						}
                        selectedUser.totalHoursUsed = updatedHour
						selectedUser.tutorHours = Number(selectedUser.tutorHours) - Number(phour)
                        calculateTotalHours(selectedUser)
						console.log(setData)
                        dispatch(updateUserDetails(setData));
						setSessionDate("")
						setSessionFrom("")
						setSessionTo("")
                        setPsValue(0)
                        setActValue(0)
                        setMiValue(0)
                        setSecValue(0)
                        setGeneralValue(0)
						setPhour(0)
						setSelectedHour(0)
                        dispatch(fetchAppHourUsedLogs({handle: selectedUser.handle}))
                        // dispatch(sendEmailApplicationHourUsed(setData))
                        setHideError(true)
                        setNoValueError("")
						setHourErrorMsg("")
                        setComment("")
                    
                    }
                })
            }
           

        }else{  
            if(errors == 1){
            }else{
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to add hours?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes,'
                }).then((result) => {
                    if (result.isConfirmed) {
						setModal1(false)
                        const setData = {
                            by: props.userDetails.handle,
                            updatedBy: assignedcoach, //? assignedcoach : props.userDetails.handle,
                            handle: selectedUser.handle,
                            updateUsedHour: useHoursObj,
							
                           	date: moment.utc(sessionDate).format(),
                            startTime: moment.utc(sessionFrom).format(),
                            endTime: moment.utc(sessionTo).format(),
                            comment: comment,
                            mailDetails: {
                                coach: props.userDetails.name,
                                coachEmail: props.userDetails.email,
                                student: selectedUser.name,
                                studentEmail: selectedUser.email,

                            }
                        }
						if(phour != 0){
							setData.updatePremiumHour = {
								category: "premium_hour",
								prev: Number(selectedUser.tutorHours),
								value : Number(selectedUser.tutorHours) - Number(phour)
							}
						
						}
                        selectedUser.totalHoursUsed = useHoursObj
						// console.log(setData)
                        calculateTotalHours(selectedUser)
                        dispatch(updateUserDetails(setData));
						setSessionDate("")
						setSessionFrom("")
						setSessionTo("")
                        setPsValue(0)
                        setActValue(0)
                        setMiValue(0)
                        setSecValue(0)
                        setGeneralValue(0)
						setPhour(0)
						setSelectedHour(0)
                        // dispatch(fetchAppHourUsedLogs({handle: selectedUser.handle}))
                        // dispatch(sendEmailApplicationHourUsed(setData))
                        setHideError(true)
                        setNoValueError("")
						setHourErrorMsg("")
                        setComment("")
        
                    }
                })
            }
        }

    }

    
    return (
		<>

            <button
                onClick={(e) => handleViewUser(e, props.item)}
                className="btn btn-sm btn-success"
            >
                View
            </button>
            <button
                onClick={(e) =>
                    editUserDetails(e, {
                    modal: true,
                    userId: props.item.userId,
                    })
                }
                    className="btn btn-sm btn-primary"
                >
                Edit
            </button>
            {![true,"true"].includes(props.item.coach) && ![true,"true"].includes(props.item.admin) &&
            <button
                onClick={(e) =>editStudentDetails(e, props.item.userId)}
                    className="btn btn-sm btn-primary text-truncate"
                >
                Log Hours
            </button>
            }
          
        <Modal className="modal-dialog-centered" size="lg" isOpen={modalUpdateUser} toggle={toggleUpdateUser} >
            <Form  onSubmit={handleSubmit(onSubmit)}>
                <ModalBody className='modal-body p-0'>
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent">
                            <Row className="align-items-center">
                                <Col xs="8"><h3 className="mb-0">Edit User</h3></Col>
                                <Col className="text-right" xs="4"></Col>
                            </Row>
                        </CardHeader>
                        <CardBody style={{maxHeight:"650px", overflowY: 'auto'}}>
                            <h6 className="heading-small text-muted mb-4">
                                User Information
                            </h6>
                            <div className="pl-lg-4">
                                <Row>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="name"
                                            >
                                                Full Name
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="name"
                                                name="name"
                                                value={watch("name")}
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="email"
                                            >
                                                Email Address
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="email"
                                                name="email"
                                                value={watch("email")}
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="tpcEntryDate"
                                            >
                                                Entry Date
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="tpcEntryDate"
                                                name="tpcEntryDate"
                                                value={watch("tpcEntryDate")}
                                                
                                                type="date"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="mcatDate"
                                            >
                                                DAT Date
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="mcatDate"
                                                name="mcatDate"
                                                value={watch("mcatDate")}
                                                
                                                type="date"
                                                onChange={e => setValue("mcatDate", e.target.value)}
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="schoolYear"
                                            >
                                                School Year
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="schoolYear"
                                                name="schoolYear"
                                                value={watch("schoolYear")}
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="university"
                                            >
                                                University
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="university"
                                                name="university"
                                                value={watch("university")}
                                                
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="admin"
                                            >
                                            Admin
                                                        </label>
                                            <select
                                                id="admin"
                                                className="form-control form-control-alternative"
                                                value={watch("admin")}
                                                onChange={e => setValue("admin", e.target.value)}
                                                >
                                                    <option value="false">No</option>
                                                    <option value="true">Yes</option>
                                            </select>

                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="coach"
                                                >
                                                Coach
                                            </label>
                                            <select
                                                id="coach"
                                                className="form-control form-control-alternative"
                                                value={watch("coach")}
                                                onChange={e => setValue("coach", e.target.value)}
                                                >
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            <hr className="my-4" />
                            <h6 className="heading-small text-muted mb-4">
                                Contact Information
                            </h6>
                            <div className="pl-lg-4">
                                <Row>
                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="homeAddress"
                                            >
                                                Address
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="homeAddress"
                                                name="homeAddress"
                                                value={watch("homeAddress")}
                                                
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="selectedCountry"
                                            >
                                                Country
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="selectedCountry"
                                                name="selectedCountry"
                                                value={watch("selectedCountry")}
                                                
                                                type="text"
                                                disabled="disabled"
                                            />  
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="selectedState"
                                            >
                                                State
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="selectedState"
                                                name="selectedState"
                                                value={watch("selectedState")}
                                            
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="selectedCity"
                                            >
                                                City
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="selectedCity"
                                                name="selectedCity"
                                                value={watch("selectedCity")}
                                            
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="postalCode"
                                            >
                                                Postal Code
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="postalCode"
                                                name="postalCode"
                                    
                                                value={watch("postalCode")}
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            <hr className="my-4" />

                            {getValues("coach") == true || getValues("coach") == "true" ?
                                <>
                                <hr className="my-4" />
                                {/* Address */}
                                <h6 className="heading-small text-muted mb-4">
                                    Coach information
                                </h6>
                                <div className="pl-lg-4">
                                    <Row>
                                    <Col lg="6">
                                        <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-city"
                                        >
                                        Title
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            
                                            value={watch("coachTitle")}
                                            placeholder="Title"
                                            type="text"
                                            onChange={ e => setValue("coachTitle", e.target.value)}
                                        />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-country"
                                        >
                                        Position
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            
                                            value={watch("coachPosition")}
                                            placeholder="Position"
                                            type="text"
                                            onChange={ e => setValue("coachPosition", e.target.value)}
                                  
                                        />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="12">
                                        <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-country"
                                        >
                                        Dental School
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            value={watch("coachDentalSchool")}
                                            
                                            placeholder="Dental School"
                                            type="text"
                                            onChange={ e => setValue("coachDentalSchool", e.target.value)}
                                   
                                        />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="12">
                                        <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-country"
                                        >
                                        Description
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            value={watch("coachDescription")}
                                     
                                            placeholder="Description..."
                                            type="textarea"
                                            onChange={ e => setValue("coachDescription", e.target.value)}
                       
                                        />
                                        </FormGroup>
                                    </Col>

                                    </Row>
                                </div>
                                </> : ""}

                            <h6 className="heading-small text-muted mb-4">
                                Other Information
                            </h6>
                            <div className="pl-lg-4">
                                <Row>
                                    {/* <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="inputUworld"
                                            >
                                                UWORLD Subscription
                                            </label>
                                            <select
                                                id="inputUworld"
                                                className="form-control form-control-alternative"
                                                

                                                value={watch("inputUworld")}
                                                onChange={e => setValue("inputUworld", e.target.value)}
                                                >
                                                <option value="claimed">Claimed</option>
                                                <option value="unclaimed">Unclaimed</option>
                                            </select>  
                                        </FormGroup>
                                    </Col> */}
                                    {/* <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="inputAamc"
                                            >
                                                AAMC Subscription
                                            </label>
                                            <select
                                                id="inputAamc"
                                                className="form-control form-control-alternative"
                                                
                                                value={watch("inputAamc")}

                                                onChange={e => setValue("inputAamc", e.target.value)}
                                                >
                                                <option value="claimed">Claimed</option>
                                                <option value="unclaimed">Unclaimed</option>
                                            </select>
                                            
                                        </FormGroup>
                                    </Col> */}
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="inputBootcamp"
                                            >
                                                Bootcamp Subscription
                                            </label>
                                            <select
                                                id="inputBootcamp"
                                                className="form-control form-control-alternative"
                                                value={watch("bootcampSubscription")}
                                                onChange={e => onChangeBootcampSubscription(e)}

                                                >
                                                <option value="claimed">Claimed</option>
                                                <option value="unclaimed">Unclaimed</option>
                                                <option value="no access">No Access</option>
                                            </select>
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="tutorHours"
                                            >
                                                Premium Tutoring Hours
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="tutorHours"
                                                name="tutorHours"
                                                
                                                value={watch("tutorHours")}
                                                type="number"
                                                onChange={ e => setValue("tutorHours", e.target.value)}
                                            />   
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="shadowHours"
                                            >
                                                Shadow Hours
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="shadowHours"
                                                name="shadowHours"
                                                
                                                value={watch("shadowGoal")}
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="clinicalHours"
                                            >
                                                Clinical Hours
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="clinicalHours"
                                                name="clinicalHours"
                                                
                                                value={watch("clinicalGoal")}
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="volunteerHours"
                                            >
                                                Volunteer Hours
                                            </label>
                                            <Input
                                                className="form-control-alternative is-invalid "
                                                id="volunteerHours"
                                                name="volunteerHours"
                                                
                                                value={watch("volunteerGoal")}
                                                type="text"
                                                disabled="disabled"
                                            />
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">  
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="ultimateAdvisingStudent"
                                            >
                                                Ultimate Advising Student 
                                            </label>
                                            
                                            <select
                                                id="ultimateAdvisingStudent"
                                                className="form-control form-control-alternative"
                                                

                                                value={watch("ultimateAdvisingStudent")}
                                                onChange={e => onChangeUltimateAdvisingStudent(e)}
                                                >
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </select>

                                            
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                            className="form-control-label"
                                            htmlFor="assignedCoach"
                                            >
                                            Assigned Coach
                                            </label>
                                            <Select
                                            placeholder="Select Coach"
                                            options={coaches}
                                            styles={customDropdown }
                                            id="assignedCoach"
                                            name="assignedCoach"
                                            onChange={handleAssignedCoach}
                                            menuPortalTarget={document.body}
                                            value={coaches.find(
                                                (option) => option.value === assignedcoach
                                            )}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                        <FormGroup>
                                            <label
                                            className="form-control-label"
                                            htmlFor="matriculated"
                                            >
                                            Matriculated
                                            </label>
                                            <Select 
                                            id="matriculated"
                                                name="matriculated"
                                                placeholder="Select school" 
                                                options={universities} 
                                                styles={customDropdown }  
                                                onChange={handleUniversityChange}
                                                menuPortalTarget={document.body}
                                                value={universities.find((option) => option.value === school)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="6">  
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="datPro"
                                            >
                                                DAT Pro 
                                            </label>
                                            
                                            <select
                                                id="datPro"
                                                className="form-control form-control-alternative"
                                                

                                                value={watch("datPro")}
                                                onChange={e => setValue("datPro", e.target.value)}
                                                >
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </select>

                                            
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" type='submit'>
                    Update
                    </Button>{' '}
                    <Button color="secondary" onClick={toggleUpdateUser}>
                    Close
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>      
        <Modal
                isOpen={modal1}
                toggle={modalToggle1}
                backdrop={backdrop1}
                size="lg"
                centered
            >
            <ModalHeader toggle={modalToggle1}>
                Manage Student's Log Hours
            </ModalHeader>
                <ModalBody className="pt-1">
                    <Row>
                    <Col className="mt-3 mb-4 d-flex justify-content-center">
                        <Nav fill pills>
                            { mainopt.length > 0
                                ? mainopt.map((c, i) => {
                                    return (
                                    <NavItem className="ml-1" key={i}>
                                        <NavLink
                                        key={c}
                                        className={classnames({
                                            active: mainActiveTab === c,
                                        })}
                                        onClick={() => {
                                            toggleMain(c);
                                        }}
                                        style={{ cursor: "pointer" }}
                                        >
                                        {c}
                                        </NavLink>
                                    </NavItem>
                                    );
                                })
                                :  ""
                            }
                        </Nav>
                    </Col>
                </Row>
                <Row>
                    <Col lg="12" className="mt-3 p-2">
                        <TabContent activeTab={mainActiveTab}>
                            {mainopt.map((mc, i) => (
                                <TabPane tabId={mc} key={i}>
                                    {
                                        mc == "Log Hours" ?
                                            userDetailsLoading ? 

                                                <div className="m-5">
                                                    <Alert color="secondary" className="text-center">
                                                        Fetching student details.. Please wait while loading {" "}
                                                        <Spinner size="sm" color="primary" />{" "}
                                                    </Alert>
                                                </div>
                                            :
                                            <>
                                                <Card className="mb-2 shadow">
                                                    <CardBody>
                                                        
                                                        <Row>
                                                            <Col xl="6" className="d-flex align-items-center">
                                                                {
                                                                    selectedUser ? 
                                                                        <Media className="align-items-center">
                                                                            {
                                                                                typeof selectedUser.profilePicture != "undefined" ? (
                                                                                    <div className="media">
                                                                                        <img 
                                                                                            src={"https://storage.googleapis.com/pre-dental-tracker.appspot.com/profile-picture/" + selectedUser.profilePicture}
                                                                                            className="mr-3" 
                                                                                            alt="..." 
                                                                                            style={{
                                                                                                width: "60px",
                                                                                                height: "60px", 
                                                                                                objectFit: "cover"
                                                                                            }}
                                                                                        />
                                                                                        <div className="media-body">
                                                                                            <h4 className="mt-0">{selectedUser.name}</h4>
                                                                                            <small>{selectedUser.email}</small>
                                                                                        
                                                                                        </div>
                                                                                    </div>
                                                                            
                                                                                ) : 
                                                                                (
                                                                                    <div className="media">
                                                                                        <div className="rounded-circle profile-letter-all-users mr-2" 
                                                                                            style={{
                                                                                            width: "60px",
                                                                                            height: "60px",
                                                                                                fontSize: "16px"
                                                                                                }}>
                                                                                                {selectedUser.name !== undefined ? selectedUser.name.trim()[0].toUpperCase() : "1" }
                                                                                        </div>
                                                                                        <div className="media-body">
                                                                                            <h5 className="my-0">{selectedUser.name}</h5>
                                                                                            <small>{selectedUser.email}</small>
                                                                                        
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                            
                                                                        </Media>
                                                                    : ""
                                                                }
                                                            </Col>
                                                            <Col xl="6"  className="mt-2">
                                                                <Card className="card-stats mb-4 mb-xl-1 w-100 shadow">
                                                                    <CardBody>
                                                                        <Row>
                                                                            <div className="col">
                                                                                <CardTitle
                                                                                    tag="h5"
                                                                                    className="text-uppercase mb-0"
                                                                                >
                                                                                    Application Hours Used
                                                                                </CardTitle>
                                                                            
                                                                            </div>
                                                                            <Col className="col-auto">
                                                                                <span className="h2 font-weight-bold mb-0">
                                                                                    {totalHour}
                                                                                </span>
                                                                                {/* <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                                                                                    <i className="fas fa-atom" />
                                                                                </div> */}
                                                                            </Col>
                                                                        </Row>
                                                                    </CardBody>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    
                                                    </CardBody>
                                                </Card>
                                                
                                                <Row className="mt-3" >
                                                
                                                    <Col lg="6" >
                                                        <FormGroup>
                                                            <Label >Date <span className="text-danger">*</span></Label>
                                                            <ReactDatetime
                                                                onChange={(e) => handleChangeDate(e)}
                                                                timeFormat={false}
                                                                value={sessionDate || ""} 
                                                                className="w-100"
                                                                inputProps={{ placeholder: "Select Date" }}
                                                                
                                                            />
                                                            <Input
                                                                type="hidden"
                                                                onChange={(e) => handleChangeDate(e)}
                                                                value={sessionDate} 
                                                                invalid={!hideError ? sessionDate ? "" : "true" : ""}
                                                            />
                                                            <FormFeedback>This field is required!</FormFeedback>
                                                        </FormGroup>
                                                        
                                                        <FormGroup >
                                                            <Label >From <span className="text-danger">*</span></Label>
                                                            <ReactDatetime
                                                                value={sessionFrom}
                                                                onChange={(e) => handleChangeFrom(e)}
                                                                timeConstraints={{
                                                                minutes: { min: 30, max: 30, step: 31 },
                                                                }}
                                                                dateFormat={false}
                                                                className="w-100"
                                                                inputProps={{ placeholder: "Select Start Time" }}
                                                                
                                                            />
                                                            <Input
                                                                type="hidden"
                                                                value={sessionFrom}  
                                                                onChange={(e) => handleChangeFrom(e)}
                                                                invalid={!hideError ? sessionFrom ? "" : "true" : ""}
                                                            />
                                                            
                                                            <FormFeedback>This field is required!</FormFeedback>
                                                        </FormGroup>
                                                        <FormGroup >
                                                            <Label >To <span className="text-danger">*</span></Label>
                                                            <ReactDatetime
                                                                value={sessionTo}
                                                                onChange={(e) => handleChangeTo(e)}
                                                                timeConstraints={{
                                                                minutes: { min: 30, max: 30, step: 31 },
                                                                }}
                                                                dateFormat={false}
                                                                className="w-100"
                                                                inputProps={{ placeholder: "Select End Time" }}
                                                                invalid={!hideError ? sessionTo ? "" : "true" : ""}
                                                            />
                                                            <Input
                                                                type="hidden"
                                                                value={sessionTo} onChange={(e) => handleChangeTo(e)}
                                                                invalid={!hideError ? sessionFrom ? "" : "true" : ""}
                                                            />
                                                            <FormFeedback>This field is required!</FormFeedback>
                                                        </FormGroup>
                                                        
                                                        
                                                        
                                                    </Col>
                                                
                                                    <Col lg="6">
                                                        {/* {
                                                            props.userDetails.admin == true ?    */}
                                                            <FormGroup>
                                                                <Label >Select Coach <span className="text-danger">*</span></Label>
                                                                <Select

                                                                    options={coachOption}
                                                                    classNamePrefix="select"
                                                                    placeholder="Select a Coach.."
                                                                    onChange={handleAssignedCoach}
                                                                    value={coaches.find(
                                                                        (option) => option.value === assignedcoach
                                                                    )}
                                                                    formatOptionLabel={(v) => (
                                                                        <div className="d-flex ">
                                                                            {v.value ? (
                                                                            v.image ? (
                                                                                <img
                                                                                className="rounded-circle  mr-1 "
                                                                                style={{ width: "25px", height: "25px" }}
                                                                                src={
                                                                                    "https://storage.googleapis.com/tpcdashboard.appspot.com/profile-picture/" +
                                                                                    v.image
                                                                                }
                                                                                alt={v.label}
                                                                                />
                                                                            ) : (
                                                                                <div
                                                                                className="rounded-circle profile-letter-all-users mr-1 "
                                                                                style={{ width: "25px", height: "25px" }}
                                                                                >
                                                                                {v.label ? v.label.trim()[0] : ""}
                                                                                </div>
                                                                            )
                                                                            ) : (
                                                                            ""
                                                                            )}

                                                                            <span>{v.label}</span>
                                                                        </div>
                                                                    )}
                                                                />
                                                            </FormGroup>
                                                            
                                                            {/* : ""
                                                        } */}
                                                    
                                                        <FormGroup>
                                                            <Label >Comment <span className="text-danger">*</span></Label>
                                                            <Input type="textarea" name="text" rows="6" placeholder="Write a comment here..."  value={comment} onChange={handleCommentChange} invalid={!hideError ? comment ? "" : "true" : ""}  />
                                                            <FormFeedback>This field is required!</FormFeedback>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                

                                                    {
                                                        typeof selectedUser.totalHoursUsed !== "undefined" 
                                                        ? 
                                                        <>
                                                        {
                                                            useHoursObj.map(hObject => ({
                                                            ...hObject,
                                                            ...selectedUser.totalHoursUsed.find(myhours => myhours.category === hObject.category)
                                                            })).map((v, i) => (
                                                                <Col  xl="6" className="mb-1" key={i}>
                                                                    <Card className="card-stats mb-4 mb-xl-0 w-100">
                                                                        <CardBody>
                                                                            <Row>
                                                                                <div className="col">
                                                                                    <CardTitle
                                                                                        tag="h5"
                                                                                        className="text-uppercase text-muted mb-0"
                                                                                    >
                                                                                        {v.category.replace('_',' ')}
                                                                                    </CardTitle>
                                                                                    <span className="h2 font-weight-bold mb-0">
                                                                                        {v.value}
                                                                                    </span>
                                                                                </div>
                                                                                <Col className="col-auto">
                                                                                    <Select 
                                                                                        
                                                                                        placeholder='Add..'
                                                                                        options={hourOptions} 
                                                                                        styles={customDropdown }  
                                                                                        onChange={(e) => handleHours({category: v.category, value: e.value})}
                                                                                        menuPortalTarget={document.body}
                                                                                        value={hourOptions.find((option) => option.value === selectedHour)}
                                                                                        
                                                                                    />  
                                                                                </Col>
                                                                            </Row>
                                                                        </CardBody>
                                                                    </Card>
                                                                </Col>
                                                        
                                                            ))
                                                        }
                                                                <Col  xl="6" className="mb-1">
                                                                    <Card className="card-stats mb-4 mb-xl-0 w-100">
                                                                        <CardBody>
                                                                            <Row>
                                                                                <div className="col">
                                                                                    <CardTitle
                                                                                        tag="h5"
                                                                                        className="text-uppercase text-primary mb-0"
                                                                                    >
                                                                                    Premium Hours	
                                                                                    </CardTitle>
                                                                                    <span className="h2 font-weight-bold mb-0">
                                                                                        {selectedUser.tutorHours}
                                                                                    </span>
                                                                                </div>
                                                                                <Col className="col-auto">
                                                                                    <Select 
                                                                                        placeholder='Deduct..'
                                                                                        options={hourOptions} 
                                                                                        styles={customDropdown }  
                                                                                        onChange={(e) => handleHours({category: 'premium_hour', value: e.value})}
                                                                                        menuPortalTarget={document.body}
                                                                                        
                                                                                        value={hourOptions.find((option) => option.value === phour)}
                                                                                        
                                                                                    />  
                                                                                </Col>
                                                                            </Row>
                                                                        </CardBody>
                                                                    </Card>
                                                                </Col>
                                                            </>
                                                        : 
                                                        <>
                                                            {
                                                                useHoursObj.map((v,i)=>(
                                                                    <Col  xl="6" className="mb-1" key={i}>
                                                                        <Card className="card-stats mb-4 mb-xl-0 w-100">
                                                                            <CardBody>
                                                                                <Row>
                                                                                    <div className="col">
                                                                                        <CardTitle
                                                                                            tag="h5"
                                                                                            className="text-uppercase text-muted mb-0"
                                                                                        >
                                                                                            {v.category.replace('_',' ')}
                                                                                        </CardTitle>
                                                                                        <span className="h2 font-weight-bold mb-0">
                                                                                            0
                                                                                        </span>
                                                                                    </div>
                                                                                    <Col className="col-auto">
                                                                                        <Select 
                                                                                            placeholder='Add..'
                                                                                            options={hourOptions} 
                                                                                            styles={customDropdown }  
                                                                                            onChange={(e) => handleHours({category: v.category, value: e.value})}
                                                                                            menuPortalTarget={document.body}
                                                                                            
                                                                                            value={hourOptions.find((option) => option.value === selectedHour)}
                                                                                            
                                                                                        />  
                                                                                    </Col>
                                                                                </Row>
                                                                            </CardBody>
                                                                        </Card>
                                                                    </Col>
                                                                ))
                                                            }
                                                                <Col  xl="6" className="mb-1">
                                                                    <Card className="card-stats mb-4 mb-xl-0 w-100">
                                                                        <CardBody>
                                                                            <Row>
                                                                                <div className="col">
                                                                                    <CardTitle
                                                                                        tag="h5"
                                                                                        className="text-uppercase text-primary mb-0"
                                                                                    >
                                                                                    Premium Hours	
                                                                                    </CardTitle>
                                                                                    <span className="h2 font-weight-bold mb-0">
                                                                                        {selectedUser.tutorHours}
                                                                                    </span>
                                                                                </div>
                                                                                <Col className="col-auto">
                                                                                    <Select 
                                                                                        placeholder='Deduct..'
                                                                                        options={hourOptions} 
                                                                                        styles={customDropdown }  
                                                                                        onChange={(e) => handleHours({category: 'premium_hour', value: e.value})}
                                                                                        menuPortalTarget={document.body}
                                                                                        value={hourOptions.find((option) => option.value === phour)}
                                                                                        
                                                                                    />  
                                                                                </Col>
                                                                            </Row>
                                                                        </CardBody>
                                                                    </Card>
                                                                </Col>
                                                        </>
                                                    }

                                                </Row>
                                                <Row>
                                                    <Col lg="12"> { noValueError ? <Alert color="danger" className="mt-2">{noValueError}</Alert>  : ""}</Col>
                                                    <Col lg="12"> { hourErrorMsg ? <Alert color="danger" className="mt-2">{hourErrorMsg}</Alert>  : ""}</Col>
                                                </Row>
                                                <Row>
                                                    <Col xl="12" className="mt-2">
                                                    
                                                        {
                                                            selectedUser.handle ? ""
                                                                // <StudentFreeHourLogs studenthandle={selectedUser.handle} />
                                                            : ""
                                                        }
                                                            
                                                    </Col>
                                                    
                                                </Row>  
                                            </>
                                            
                                    :
                                    <Row>
                                        <Col lg="12" className="mt-2"><StudentFreeHourLogs studenthandle={selectedUser.handle} /></Col>
                                    </Row>
                                    }
                                    </TabPane>
                                ))
                            }   
                        </TabContent>           
                    </Col>
                </Row> 
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={modalToggle1} >
                Close
                </Button>
                
                <Button color="primary" onClick={saveUserSession} disabled={ !assignedcoach ? true : false } >
                Save
                </Button>
            </ModalFooter>
        </Modal>
		</>
	);
};

const mapStateToProps = (state) => {
  return {
    fetchAllUsers: state.fetchAllUsers,
    fetchUserDetails: state.fetchUserDetails,
    updateUserDetails: state.updateUserDetails,
    updateMultiUsersReducer: state.updateMultiUsersReducer,
    fetchCoaches: state.fetchCoaches,
    userDetails : state.loginAuth.userDetails,
    fetchUniversities : state.fetchUniversities,
  };
};

export default connect(mapStateToProps)(ManageUsersModal);
